import React from 'react';
import { hasCookieError } from 'app/api/redux-bridge/session/selectors';
import { COOKIE_ERROR } from 'app/api/redux-route/routes';
import connect from 'app/api/redux-util/connect-enhancer';
import RouteRenderer from './RouteRenderer';

class CookieRoute extends React.Component {
  render() {
    const { cookieError, ...restProps } = this.props;
    return (
      <RouteRenderer
        hasAccess={!cookieError}
        redirectTo={COOKIE_ERROR}
        {...restProps}
      />
    );
  }
}

const mapStateToProps = state => ({
  cookieError: hasCookieError(state),
});

export default connect(mapStateToProps)(CookieRoute);
